import { predecessorNumber } from "./statement-numbers";

/**
 * The nearest earlier family member that still stands, stepping back over void members.
 *
 * Matches the statement-generation bot, which bills a new sub-statement from the latest member
 * that is not void. With `0245-1` void, `0245-2` resolves to `0245`.
 *
 * @param statementNumber A statement number.
 * @param voidNumbers The family's void member numbers, which are stepped over.
 * @returns The live predecessor's number, or `undefined` for a primary or when every predecessor
 *   is void.
 */
export function livePredecessorNumber(
  statementNumber: string,
  voidNumbers: ReadonlySet<string>,
): string | undefined {
  let candidate = predecessorNumber(statementNumber);
  while (candidate !== undefined && voidNumbers.has(candidate)) {
    candidate = predecessorNumber(candidate);
  }
  return candidate;
}

/**
 * Whether a statement number names a sub-statement, such as `0245-1`.
 *
 * @param statementNumber A statement number, or `undefined` for a statement with none.
 * @returns True when the number has a predecessor.
 */
export function isSubStatementNumber(statementNumber: string | undefined): boolean {
  return statementNumber !== undefined && predecessorNumber(statementNumber) !== undefined;
}
